import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PARTNER_PORTAL_PROJECT_DETAIL_BASE } from '../../Constants/partnerRoutes';
import PartnerTableSortFilterHeader from '../shared/PartnerTableSortFilterHeader';
import { MY_PROJECTS_TABLE_COLUMNS } from '../../Utils/partnerTableSortFilterUtils';
import { formatPartnerTableDate } from '../../Utils/partnerDateUtils';
import { getMyProjectTableStatusMeta } from '../../Utils/partnerProjectStatusUtils';
import PartnerTablePrimaryCell from './PartnerTablePrimaryCell';
import PartnerTableProductsCell from './PartnerTableProductsCell';
import PartnerTableStatusCell from './PartnerTableStatusCell';
import PartnerTableActionsCell from './PartnerTableActionsCell';

const ProjectTable = ({
  projects,
  mode = 'partner',
  onViewProject,
  onDeleteProject,
  sortKey = null,
  sortDirection = null,
  onSort = () => {},
}) => {
  const navigate = useNavigate();
  const isPAEMode = mode === 'pae' || mode === 'psm';

  const navigateToDetails = (projectId) => {
    if (isPAEMode) {
      navigate(`/partner-portal/pae/project/${projectId}`);
      return;
    }
    if (onViewProject) {
      onViewProject(projectId);
      return;
    }
    navigate(`${PARTNER_PORTAL_PROJECT_DETAIL_BASE}/${projectId}`);
  };

  return (
    <div className="partner-table-container partner-my-projects-table">
      <table className="table partner-table partner-my-projects-table partner-portal-list-table">
        <colgroup>
          <col className="partner-col-customer" />
          <col className="partner-col-company" />
          <col className="partner-col-products" />
          <col className="partner-col-engagement" />
          <col className="partner-col-status" />
          <col className="partner-col-est-start" />
          <col className="partner-col-est-golive" />
          <col className="partner-col-act-start" />
          <col className="partner-col-act-golive" />
          <col className="partner-col-submitted" />
          <col className="partner-col-actions" />
        </colgroup>
        <thead>
          <tr>
            {MY_PROJECTS_TABLE_COLUMNS.map((column) => (
              <PartnerTableSortFilterHeader
                key={column.key}
                label={column.label}
                columnKey={column.key}
                sortKey={sortKey}
                sortDirection={sortDirection}
                onSort={onSort}
                sortable={column.sortable}
                className={
                  column.key === 'status'
                    ? 'partner-table-status-head'
                    : column.key === 'submitted'
                      ? 'partner-table-submitted-head'
                      : ['estStart', 'estGolive', 'actStart', 'actGolive'].includes(column.key)
                        ? 'partner-table-date-head'
                        : ''
                }
              />
            ))}
            <PartnerTableSortFilterHeader actions />
          </tr>
        </thead>
        <tbody>
          {projects.map((project) => {
            const statusMeta = getMyProjectTableStatusMeta(project.projectStatus);
            return (
              <tr key={project.id} className="partner-clickable-row">
                <td>
                  <PartnerTablePrimaryCell
                    title={project.customerName}
                    subtitle={project.deploymentModel || 'SaaS'}
                  />
                </td>
                <td className="partner-table-company-cell">{project.companyName || '-'}</td>
                <td>
                  <PartnerTableProductsCell
                    products={project.productsInScope}
                    rowKeyPrefix={project.id}
                  />
                </td>
                <td className="partner-table-engagement-cell">{project.engagementType || '-'}</td>
                <PartnerTableStatusCell meta={statusMeta} />
                <td className="partner-table-date-cell">{formatPartnerTableDate(project.estimatedStartDate)}</td>
                <td className="partner-table-date-cell">{formatPartnerTableDate(project.estimatedGoliveDate)}</td>
                <td className="partner-table-date-cell">{formatPartnerTableDate(project.actualStartDate)}</td>
                <td className="partner-table-date-cell">{formatPartnerTableDate(project.actualGoliveDate)}</td>
                <td className="partner-table-submitted-cell" title={project.partnerName || project.submittedBy || ''}>
                  {project.partnerName || project.submittedBy || '-'}
                </td>
                <PartnerTableActionsCell
                  onView={() => navigateToDetails(project.id)}
                  onDelete={onDeleteProject ? () => onDeleteProject(project.id) : undefined}
                />
              </tr>
            );
          })}
          {projects.length === 0 ? (
            <tr>
              <td colSpan={MY_PROJECTS_TABLE_COLUMNS.length + 1} className="text-center">No projects found.</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectTable;
